<script lang="ts">
  import PostHeart from '$icons/PostHeartIcon.svelte';
  import UserWrapper from '$lib/components/common/user/userWrapper.svelte';
  import SeedIcon from '$lib/icons/SeedIcon.svelte';
  import { likeComment, unlikeComment } from '$src/utils/api/comments.util';
  import type { IComment } from 'garden-common';
  import prettyMilliseconds from 'pretty-ms';

  import { createEventDispatcher, onMount } from 'svelte';

  export let c: IComment<string>;
  export let i: number;
  export let comments: IComment<string>[];
  export let me: any;

  let childComments: any = [];

  // This logic should probably be handled by the parent component
  function getChildren(c: IComment<string>, comments: IComment<string>[]) {
    let children: any = [];
    for (let i = 0; i < comments.length; i++) {
      const comment = comments[i];
      if (!c._id || !comment.parentComment) continue;

      if (comment.parentComment === c._id) {
        children.push(comment);
        children = children;
      }
    }

    return children;
  }

  function prettyDate(date: string | Date) {
    return prettyMilliseconds(new Date().getTime() - new Date(date).getTime(), {
      compact: true,
      unitCount: 1,
      secondsDecimalDigits: 0
    });
  }

  const dispatch = createEventDispatcher();

  onMount(() => {
    childComments = getChildren(c, comments);
  });
</script>

<div
  class="w-full p-1 {i !== comments.length - 1
    ? 'border-b border-neutral-800 border-opacity-5'
    : ''} flex-col items-start gap-2 inline-flex"
>
  <div class="items-center gap-2 inline-flex justify-between w-full">
    <UserWrapper
      padding={false}
      nameClass="text-slate-500 text-sm font-medium leading-tight"
      username={false}
      cls={'w-7 h-7'}
      user={c.commentPoster}
    />
    {#if c.commentPrice}
      <div class="flex text-sm gap-2 text-opacity-50 items-center">
        <SeedIcon /> {c.commentPrice}
      </div>
    {/if}
  </div>
  <div class="flex-col items-start gap-2 flex">
    <div class=" self-stretch text-gray-700 text-base font-normal leading-normal whitespace-normal">
      {c.commentText}
    </div>
    <div class=" items-center gap-3 flex">
      {#if me?._id !== c.commentPoster?._id}
        <button
          on:click={async () => {
            const isLikedByMe = c.likes.includes(me._id);
            const isMyComment = me._id === c.commentPoster._id;

            if (!isLikedByMe && !isMyComment) {
              c.likes.push(me._id);
              c.likes = c.likes;

              await likeComment(c._id);
            } else if (isLikedByMe) {
              const index = c.likes.indexOf(me._id);
              if (index !== -1) {
                c.likes.splice(index, 1);
                c.likes = c.likes;

                await unlikeComment(c._id);
              }
            }
          }}
          class=" items-center gap-1 flex"
        >
          <div class="justify-center items-center flex">
            <PostHeart
              class={c.likes.includes(me?._id) ? 'fill-color-red-base' : null}
              size={17}
            />
          </div>
          <div class="text-gray-600 text-sm font-medium leading-tight">
            {c.likes.length}
          </div>
        </button>
      {/if}

      <div class="flex gap-2">
        <div class="text-neutral-800 text-opacity-25 text-sm font-medium leading-tight">
          {#if c.createdAt}
            {prettyDate(c.createdAt)} ago
          {/if}
        </div>
        <button
          class="text-neutral-800 text-opacity-50 hover:text-brand-green-50 hover:text-opacity-100 transition-all duration-300 text-sm font-medium leading-tight"
          on:click={() => dispatch('reply', c)}
        >
          Reply
        </button>
      </div>
    </div>
  </div>
</div>
<div class="pl-8 gap-3">
  {#if childComments.length !== 0}
    {#each childComments.sort((a, b) => new Date(a.createdAt).valueOf() - new Date(b.createdAt).valueOf()) as childC, childI}
      <svelte:self
        c={childC}
        i={childI}
        comments={getChildren(childC, comments)}
        {me}
        on:reply={() => dispatch('reply', childC)}
      />
    {/each}
  {/if}
</div>
